// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

export const Q1_SUPPORTING_TEXT = `Recidiviz is not auto-filling this score. \
Please refer to Pilot User’s Guide Appendix I: Prior Violent/Assaultive Felonies to score \
this question. Recidiviz is auto-filling supporting information \
based on the resident’s sentence history, as found in eTOMIS, where \
convictions are considered prior if they did not occur on the resident’s most \
recent felony Sentence Imposed Date.`;

export const Q2_SUPPORTING_TEXT = `Please refer to Pilot User’s Guide Appendix \
V: Offense Severity Levels to score this question. Recidiviz is auto-filling \
supporting information based on the resident’s sentencing information, as \
found in eTomis.`;

export const DISCIPLINARY_RECORD_SUPPORTING_TEXT = `Recidiviz is auto-filling \
this score based on the resident’s disciplinary record using data from eTOMIS.`;

export const AGE_SUPPORTING_TEXT =
  "Recidiviz is auto-filling this score based on the resident’s age using data from eTOMIS.";

export const PROGRAM_COMPLETION_SUPPORTING_TEXT =
  "Recidiviz is auto-filling this score based on the resident’s class and job history in eTOMIS.";

export const BLOCKED_DOWNLOAD_MISSING_FIELDS_TOOLTIP =
  "Please fill out CAF questions 1 thru 7 before downloading";

export const BLOCKED_DOWNLOAD_MISSING_HEARING_DATE =
  "Please specify a hearing date in the Classification Hearing Notice";

export const BLOCKED_DOWNLOAD_TRUSTEE_INCOMPLETE =
  "Please complete the Trustee Assessment before downloading";

export const BLOCKED_DOWNLOAD_WRONG_VERSION_OLD =
  "Use RCAF V2 for June reclassifications (dated May 26 or later)";

export const BLOCKED_DOWNLOAD_WRONG_VERSION_NEW =
  "Do not use RCAF V2 for reclassifications prior to June (dated May 25 or earlier)";
